<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-03-03 09:20:19
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-22 14:47:22
 * @FilePath: \newsmartmapout\src\views\waringpage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mywarningBox" id="cesiumContainer">
    <div class="myBtnBox33" @click="goback">返回</div>
  </div>
</template>

<script>
import mymodel from "../assets/tileset.json";
import RainEffect from "../utils/cesiumCtrl/rain.js";
export default {
  data() {
    return {
      _viewer: null,
      waterEntity: null,
      waterTimer: null
    };
  },
  mounted() {
    Cesium.Ion.defaultAccessToken =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4ZjMzOWMzOC0zZjE3LTQ3ZWMtODUzNy05MDg2MTM1ZDMzNjUiLCJpZCI6MTk0ODA0LCJpYXQiOjE3MDc1NzUxMDZ9.WsxbulVE8V2usQQpuKF5wcoAWAvKgzpUyMlWtlb98sI";
    this._viewer = new Cesium.Viewer("cesiumContainer", {
    //  terrain: Cesium.Terrain.fromWorldTerrain(),
    });

   this._viewer.scene.setTerrain(
  new Cesium.Terrain(
    Cesium.CesiumTerrainProvider.fromIonAssetId(1),
  ),
);

    this._viewer.camera.setView({
      // fromDegrees()方法，将经纬度和高程转换为世界坐标
      destination: Cesium.Cartesian3.fromDegrees(103.18, 30.59, 5000.0),
      orientation: {
        // 指向
        heading: Cesium.Math.toRadians(0, 90),
        // 视角
        pitch: Cesium.Math.toRadians(-90),
        roll: 0.0
      }
    });
    let position = Cesium.Cartesian3.fromDegrees(
      102.36177647213513,
      29.229893497570806,
      1000
    );
    const heading = Cesium.Math.toRadians(45);
    const pitch = 0;
    const roll = 0;
    const hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
    const orientation = Cesium.Transforms.headingPitchRollQuaternion(
      position,
      hpr
    );
    let entity = this._viewer.entities.add({
      name: "scene",
      position: position,
      description: "<div><p>石棉县大岗山水电站<p></div>",
      orientation: orientation,
      model: {
        uri: "./model/scene.glb",
        // minimumPixelSize: 5000,
        // maximumScale: 100,
        scale: 5,
        //  silhouetteSize: parseFloat(2),
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
      }
    });
    let position2 = Cesium.Cartesian3.fromDegrees(102.837547, 29.209485, 1000);
    // const heading = Cesium.Math.toRadians(45);
    // const pitch = 0;
    // const roll = 0;
    // const hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
    // const orientation = Cesium.Transforms.headingPitchRollQuaternion(
    //   position,
    //   hpr
    // );
    let entity2 = this._viewer.entities.add({
      name: "scene",
      position: position2,
      description: "<div><p>汉源县瀑布沟水电站<p></div>",
      orientation: orientation,
      model: {
        uri: "./model/scene.glb",
        // minimumPixelSize: 5000,
        // maximumScale: 100,
        scale: 20,
        //  silhouetteSize: parseFloat(2),
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
      }
    });

    console.log(this.$route.query.id);
    // this._viewer.trackedEntity = entity2;
    if (this.$route.query.id == "汉源县瀑布沟水电站") {
      this._viewer.trackedEntity = entity2;
    } else {
      this._viewer.trackedEntity = entity;
    }
    this.addWaterAnimate();
    // const modelEntity = this._viewer.entities.add({
    //     name: 'model layer',
    //     position: position,
    //     orientation: orientation,
    //     model: {
    //         uri: './model/scene.gltf',
    //         minimumPixelSize: 128,
    //         maximumScale: 20000,
    //     },
    // });
    // this.load3Dtiles('https://data.mars3d.cn/3dtiles/max-fsdzm/tileset.json');
    // viewer.scene.globe.depthTestAgainstTerrain = true;
    // const startLon = 117.0;
    // const startLat = 32.0;
    // const endLon = 117.01;
    // const endLat = 32.0;

    // var terrainProvider = new Cesium.CesiumTerrainProvider({
    //   url: "//cesiumjs.org/smallterrain"
    // });
    // var positions = [
    //   Cesium.Cartographic.fromDegrees(86.925145, 27.988257),
    //   Cesium.Cartographic.fromDegrees(87.0, 28.0)
    // ];
    // var promise = Cesium.sampleTerrain(terrainProvider, 11, positions);
    // console.log(promise);
    // // Cesium.when(promise, function(updatedPositions) {
    // //   console.log(updatedPositions);
    // //     // positions[0].height and positions[1].height have been updated.
    // //     // updatedPositions is just a reference to positions.
    // // });
    // console.log(promise);
    // // 预计算滑坡路径上的地形高度

    // // const positions = [];
    // // const samples = 20;
    // // for (let i = 0; i <= samples; i++) {
    // //   const progress = i / samples;
    // //   const lon = startLon + (endLon - startLon) * progress;
    // //   const lat = startLat + (endLat - startLat) * progress;
    // //   positions.push(Cesium.Cartographic.fromDegrees(lon, lat));
    // // }
    // // Cesium.sampleTerrain(viewer.terrainProvider, 11, positions);
    // // // console.log(positions.map(pos => pos.height));
    // console.log(positions);

    return;

    // this.set3Dtitle3();
    // const terrainProvider = new Cesium.CesiumTerrainProvider({
    //   url: Cesium.IonResource.fromAssetId(2275207)
    //   // requestWaterMask: true, //请求水体效果所需要的海岸线数据
    //   // requestVertexNormals: true //请求地形照明数据
    // });
  },
  methods: {
    goback(){
      this.$router.back()
    },
    addWaterAnimate() {
      let that = this;
      let globe = this._viewer.scene.globe;
      globe.depthTestAgainstTerrain = true;
      // this._viewer.camera.setView({//定位到范围中心点
      //     destination: Cesium.Cartesian3.fromDegrees(87.07131373100303, 29.40857655725876, 12000),
      //     orientation: {
      //         heading: Cesium.Math.toRadians(130.304929908965146),//1
      //         pitch: Cesium.Math.toRadians(-17.364771143804237),
      //         roll: 0.09931507517437696
      //     }
      // });

      let points = [
        [102.82043697204799, 29.224408105448692],
        [102.8234323353528, 29.189370266794004],
        [102.86962870113798, 29.193137501646916],
        [102.86781829747416, 29.228654281461264]
      ];
      let points3 = [
        [ 102.83136287162361,29.204871964853517],
        [102.83923620414184,29.211215975069123 ],
        [102.83782627616692,29.226709331781347 ],
        [102.82117512351866,29.22476180995584 ]
      ];
      let points4 = [
        [ 102.83136287162361,29.204871964853517],
        [102.83923620414184,29.211215975069123 ],
        [ 102.85084094252358,29.20914203795181],
        [ 102.8479656146178,29.201444045690806]
      ];
      let points2 = [
        [ 102.35481922406234,29.235895600613546],
        [102.36152851572453,29.22979535438663],
        [ 102.36198783279364,29.230084843351698],
        [102.35585266849827,29.236214937641876 ]
      ];
       let points5 = [
        [ 102.36165343623078,29.22967166088319],
        [102.36361306052031,29.22762005575158 ],
        [ 102.36401002144888,29.227887745572453 ],
        [102.36202521680597 ,29.229982000606082 ]
      ];
       let points6 = [
        [ 102.31364410348299,29.252116517625335],
        [ 102.37982831953748,29.25929494258048],
        [ 102.38971625585096, 29.22673611822545],
        [102.31775806238714,29.21974438182528 ]
      ];
       let points7 = [
        [102.76853989248093,29.297113964847004 ],
        [ 102.93801745899154,29.287524572272666 ],
        [102.94783322058743,29.156254611583325 ],
        [102.74574401126075,29.15499400846429  ]
      ];
      // let points2 = [
      //   [102.3548359769291, 29.235914666502236],
      //   [102.3635933101928, 29.22791858763404],
      //   [102.3638873096955, 29.228161441158285],
      //   [102.35562726201947, 29.236502918906687]
      // ];
      let polygonArr = [];
      for (let i = 0; i < points3.length; i++) {
        polygonArr.push(points3[i][0]);
        polygonArr.push(points3[i][1]);
        polygonArr.push(0);
      }
      let polygonArr4 = [];
      for (let i = 0; i < points4.length; i++) {
        polygonArr4.push(points4[i][0]);
        polygonArr4.push(points4[i][1]);
        polygonArr4.push(0);
      }
      let polygonArr2 = [];
      for (let i = 0; i < points2.length; i++) {
        polygonArr2.push(points2[i][0]);
        polygonArr2.push(points2[i][1]);
        polygonArr2.push(0);
      }
      let polygonArr5 = [];
      for (let i = 0; i < points5.length; i++) {
        polygonArr5.push(points5[i][0]);
        polygonArr5.push(points5[i][1]);
        polygonArr5.push(0);
      }
      let polygonArr6 = [];
      for (let i = 0; i < points6.length; i++) {
        polygonArr6.push(points6[i][0]);
        polygonArr6.push(points6[i][1]);
        polygonArr6.push(0);
      }
      let polygonArr7 = [];
      for (let i = 0; i < points7.length; i++) {
        polygonArr7.push(points7[i][0]);
        polygonArr7.push(points7[i][1]);
        polygonArr7.push(0);
      }

      that.drawWater(800, polygonArr);
      that.drawWater(730, polygonArr4);
      that.drawWater(730, polygonArr7);
      that.drawWater2(850, polygonArr2);
      that.drawWater2(840, polygonArr5);
      that.drawWater2(831, polygonArr6);
    },
    /**
     *
     * @param {*} targetHeight 目标高度
     * @param {*} areaCoor  范围坐标
     */
    drawWater2(targetHeight, areaCoor) {
      //                 var cby_bg_data=[
      //  102.3548359769291 ,29.235914666502236,  840,
      //   102.3635933101928,  29.22791858763404,  840,
      //   102.3638873096955, 29.228161441158285,  840,
      //    102.35562726201947,29.236502918906687, 840,

      // ];
      // var cby_bg= this._viewer.entities.add({
      //   id:"fixed_bg",
      //   name: "背景",
      //   polygon: {
      //     hierarchy: Cesium.Cartesian3.fromDegreesArrayHeights(cby_bg_data),
      //     perPositionHeight: true,
      //     material: new Cesium.ImageMaterialProperty({
      //       image:"./2-19102QF646104.png"
      //     }),//new Cesium.Color(0.29, 0.85, 0.89, 0.5), //Cesium.Color.PALETURQUOISE.withAlpha(0.5),
      //     outline: false,
      //     //outlineColor: Cesium.Color.BLUE,
      //     outlineWidth: 2, //很多电脑当宽度>1时，没用
      //   }
      // });

      // return
      let that = this;
      that._viewer.entities.remove(that.waterEntityEnd);
      that.waterEntityEnd = that._viewer.scene.primitives.add(
        new Cesium.Primitive({
          geometryInstances: new Cesium.GeometryInstance({
            geometry: new Cesium.PolygonGeometry({
              polygonHierarchy: new Cesium.PolygonHierarchy(
                Cesium.Cartesian3.fromDegreesArrayHeights(areaCoor)
              ),
              height: targetHeight
            })
          }),
          appearance: new Cesium.EllipsoidSurfaceAppearance({
            aboveGround: true,
            material: new Cesium.Material({
              fabric: {
                type: "Water",
                uniforms: {
                  normalMap: "./2-16060210595K08.jpg",
                  frequency: 1000.0,
                  animationSpeed: 0.05,
                  amplitude: 10.0
                }
              }
            })
          }),
          show: true
        })
      );
    },
    drawWater(targetHeight, areaCoor) {
      //                 var cby_bg_data=[
      //  102.3548359769291 ,29.235914666502236,  840,
      //   102.3635933101928,  29.22791858763404,  840,
      //   102.3638873096955, 29.228161441158285,  840,
      //    102.35562726201947,29.236502918906687, 840,

      // ];
      // var cby_bg= this._viewer.entities.add({
      //   id:"fixed_bg",
      //   name: "背景",
      //   polygon: {
      //     hierarchy: Cesium.Cartesian3.fromDegreesArrayHeights(cby_bg_data),
      //     perPositionHeight: true,
      //     material: new Cesium.ImageMaterialProperty({
      //       image:"./2-19102QF646104.png"
      //     }),//new Cesium.Color(0.29, 0.85, 0.89, 0.5), //Cesium.Color.PALETURQUOISE.withAlpha(0.5),
      //     outline: false,
      //     //outlineColor: Cesium.Color.BLUE,
      //     outlineWidth: 2, //很多电脑当宽度>1时，没用
      //   }
      // });

      // return
      let that = this;
      that._viewer.entities.remove(that.waterEntityEnd);
      that.waterEntityEnd = that._viewer.scene.primitives.add(
        new Cesium.Primitive({
          geometryInstances: new Cesium.GeometryInstance({
            geometry: new Cesium.PolygonGeometry({
              polygonHierarchy: new Cesium.PolygonHierarchy(
                Cesium.Cartesian3.fromDegreesArrayHeights(areaCoor)
              ),
              height: targetHeight
            })
          }),
          appearance: new Cesium.EllipsoidSurfaceAppearance({
            aboveGround: true,
            material: new Cesium.Material({
              fabric: {
                type: "Water",
                uniforms: {
                  normalMap: "./2-16060210595K08.jpg",
                  frequency: 1000.0,
                  animationSpeed: 0.05,
                  amplitude: 10.0
                }
              }
            })
          }),
          show: true
        })
      );
    },

    bagin() {
      const instance = new RainEffect(this._viewer, {
        tiltAngle: -0.2, //倾斜角度
        rainSize: 1.0, // 雨大小
        rainSpeed: 120.0 // 雨速
      });
      this.onStart();
    },
    onStart() {
      const waterCoord = [
        103.07,
        30.7,
        1500,
        103.25,
        30.7,
        1500,
        103.2,
        30.55,
        1500,
        103.03,
        30.58,
        1500
      ];

      let startHeight = 1500;
      const targetHeight = 2000;
      this.waterEntity = this._viewer.entities.add({
        polygon: {
          hierarchy: Cesium.Cartesian3.fromDegreesArrayHeights(waterCoord),
          material: Cesium.Color.fromBytes(64, 157, 253, 200),
          perPositionHeight: true,
          extrudedHeight: new Cesium.CallbackProperty(() => {
            return startHeight;
          }, false)
        }
      });
      this.waterTimer = setInterval(() => {
        if (startHeight < targetHeight) {
          startHeight += 10;
          if (startHeight >= targetHeight) {
            startHeight = targetHeight;
            clearInterval(this.waterTimer);
          }
          // 使用该方式会闪烁，改用 Cesium.CallbackProperty 平滑
          // this.waterEntity.polygon.extrudedHeight.setValue(startHeight)
        }
      }, 500);
    },
    setRainEffect: function() {
      if (this._viewer) {
        var fs =
          "uniform sampler2D colorTexture;\n\
                varying vec2 v_textureCoordinates;\n\
                \n\
                float hash(float x){\n\
                return fract(sin(x*23.3)*13.13);\n\
                }\n\
                \n\
                void main(){\n\
                    float time = czm_frameNumber / 60.0;\n\
                    vec2 resolution = czm_viewport.zw;\n\
                    vec2 uv=(gl_FragCoord.xy*2.-resolution.xy)/min(resolution.x,resolution.y);\n\
                    vec3 c=vec3(.6,.7,.8);\n\
                    float a=-.4;\n\
                    float si=sin(a),co=cos(a);\n\
                    uv*=mat2(co,-si,si,co);\n\
                    uv*=length(uv+vec2(0,4.9))*.3+1.;\n\
                    float v=1.-sin(hash(floor(uv.x*100.))*2.);\n\
                    float b=clamp(abs(sin(20.*time*v+uv.y*(5./(2.+v))))-.95,0.,1.)*20.;\n\
                    c*=v*b;\n\
                    gl_FragColor = mix(texture2D(colorTexture, v_textureCoordinates), vec4(c, 1), 0.2);\n\
                }\n\
                ";
        return this._viewer.scene.postProcessStages.add(
          new Cesium.PostProcessStage({
            name: "rainEffect",
            fragmentShader: fs
          })
        );
      }
    }
  }
};
</script>

<style>
.mywarningBox {
  height: 100%;
  width: 100%;
  /* background-color: red; */
}
.myBtnBox33 {
  height: 30px;
  width: 100px;
  background-color: #28534193;
  border-bottom: 1px solid rgba(30, 92, 96, 1);
  position: absolute;
  left: 50px;
  top: 50px;
  z-index: 9999;
  text-align: center;
  line-height: 30px;
  color: white;
}
</style>